import { FC } from 'react';

import { ButtonsWrapper, CancelButton, ModalTextWrapper, ModalWrapper } from '../ConnectToFacebookModal/Wrapper';

type CmpProps = {
  onModalClose: () => void;
};

const FacebookGroupWarning: FC<CmpProps> = ({ onModalClose }) => {
  return (
    <ModalWrapper {...{ onModalClose }}>
      <ModalTextWrapper style={{ textAlign: 'left' }}>
        <p>
          On April 22, 2024 Facebook removed all 3rd party apps in Groups. Don't worry, there are still other ways to
          live stream to Facebook.{' '}
          <a href="https://wave.video/help/articles/3346817" target="_blank">
            Learn more
          </a>
        </p>
        <p>
          <b>Options 1:</b> Stream to a Facebook page or profile Connect and live stream to a Facebook page or profile
          instead of a group. You can share that link to your Group.
        </p>
        <p>
          <b>Options 2:</b> Connect to an already created stream in the Group You can create a live stream in your
          Facebook Group and manually connect it to Wave.video.
        </p>
        <p>You will not receive comments in the studio.</p>
      </ModalTextWrapper>
      <ButtonsWrapper>
        <CancelButton variant="white-blue-border-share" size="medium" onClick={onModalClose}>
          Ok
        </CancelButton>
      </ButtonsWrapper>
    </ModalWrapper>
  );
};

export default FacebookGroupWarning;
